
import rateSys from "./rate-sys.vue";
import rateOms from "./rate-oms.vue";
import i18n from "@/config/i18n";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
@Component({
  components: {
    "rate-sys": rateSys,
    "rate-oms": rateOms
  }
})
export default class AlarmSetting extends Vue {
  private privilege: objAny = {};
  private tabsList: object[] = [
    { name: "tab1", title: i18n.t("ratamanage.tab1"), value: 1 },
    { name: "tab2", title: i18n.t("ratamanage.tab2"), value: 2 }
  ];
  private tabsActive = "tab1";
  public tabChange(data: string): void {
    this.tabsActive = data;
  }
  mounted() {
    this.privilege = this.$route.meta.privilegeVoObj;
  }
}
